// common
var MAX_LENGTH_PRICE = 8;
var MAX_LENGTH_OFFRATIO = 2;
var MAX_LENGTH_HEIGHT = 3;
var setTimeOut = '';
var GENDER_ALL = 30;
var SCROLL_Y = 0;
var pagenation = require('./components/pagenation.js');
var effect = require('./effect.js');

function isSafari() {
    return /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
}

function clean(obj, type) {
    for (var propName in obj) {
        if (!propName || obj[propName] === null || obj[propName] === undefined || obj[propName] === "") {
            delete obj[propName];
        } else if (propName != 'category' && propName != 'q' && propName != 'sort' && propName != 'tag_pair') {
            obj[propName] = obj[propName].toString().replace(/,/g, '|');
        }
    }

    switch (type) {
        case 'reset-page':
            if (obj.page) {
                obj.page = 1;
            }
            break;
        default:
            break;
    }

    return obj
}


function setQueryString(key) {
    var data = $('.js-data-controller[data-key="' + key + '"]').data('query');
    data[key] = $('.js-data-controller[data-key="' + key + '"]').data('value');
    data[key] = data[key].toString().replace(/,/g, '|');
    $('.js-data-controller').data('query', data);
}

function setQueryStringData(key, aliasKey, aliasValue) {
    var data = $('.js-data-controller[data-key="' + key + '"]').data('query');
    data[aliasKey] = aliasValue;
    $('.js-data-controller').data('query', data);
}

function setQueryStringDataSelectFilter(_this, aliasKey, aliasValue) {
    var data = $(_this).data('query');
    data[aliasKey] = aliasValue;
    $(_this).data('query', data);
}

function clearFormatNumber(value) {
    var temp = value.toString().trim();
    temp = temp.replace(/[！-～]/g, halfwidthChar => String.fromCharCode(halfwidthChar.charCodeAt(0) - 0xfee0)); // convert fullwidth to halfwidth
    temp = temp.replaceAll("[^0-9.]", "");
    temp = parseInt(temp); // parse number
    return temp;
}

function setModalChoose(key, _this, isToggle, isMultiple) {
    if (isToggle) {
        // multiple choose and can toggle
        if (isMultiple) {
            var isHasClassActive = $(_this).hasClass('modal-choose--active-2');
            var value = $('.js-data-controller[data-key="' + key + '"]').data('value').toString() || '';
            if (!isHasClassActive) { // add
                $(_this).addClass('modal-choose--active-2');
                value = value ? value.split('|') : [];
                value.push($(_this).data('value'));
            } else { // remove
                $(_this).removeClass('modal-choose--active-2');
                value = value ? value.split('|').map(v => v.trim()).filter(e => e != $(_this).data('value')) : [];
            }
            $('.js-data-controller[data-key="' + key + '"]').data('value', value.join('|'));
            setQueryString(key);
            return;
        }
        // only one choose and can toggle
        if ($(_this).hasClass('modal-choose--active-2')) {
            $(_this).removeClass('modal-choose--active-2');
            $('.js-data-controller[data-key="' + key + '"]').data('value', '');
            setQueryString(key);
            return;
        } else {
            $('.js-data-controller[data-key="' + key + '"] .modal-choose').removeClass('modal-choose--active-2');
            $(_this).addClass('modal-choose--active-2');
            $('.js-data-controller[data-key="' + key + '"]').data('value', $(_this).data('value'));
            setQueryString(key);
            return;
        }
    }
    // only one choose and must active
    $('.js-data-controller[data-key="' + key + '"] .modal-choose').removeClass('modal-choose--active');
    $(_this).addClass('modal-choose--active');
    $('.js-data-controller[data-key="' + key + '"]').data('value', $(_this).data('value'));
    setQueryString(key);
}

function setModalChooseAllOrOne(key, classdiv, type) {
    if (type == 'all') {
        let value = [];
        $(classdiv).each(function( index ) {
            $(this).addClass('modal-choose--active-2');
            value.push($(this).data('value')); 
        });
        $('.js-data-controller[data-key="' + key + '"]').data('value', value.join('|'));
    }
    else {
        if ($(classdiv).hasClass('modal-choose--active-2')) {
            $(classdiv).removeClass('modal-choose--active-2');
        }
        $('.js-data-controller[data-key="' + key + '"]').data('value', '');
        if (key == 'stock_none') {
            $('.js-data-controller[data-key="' + key + '"]').data('value', 0);
        }
    }
    setQueryString(key);
}

// Remove Tag Selected
function removeTagSelected(key, _this) {
    var currentValue = $(_this).data('value');
    // tagEffect(_this);
    $(_this).parent().remove();
    var values = $('.js-data-controller[data-key="' + key + '"]').data('value');
    if (typeof values == 'string' || typeof values == 'number') {
        values = values.toString().split('|').map(v => v.trim());
    }
    //Count remain tags for each section (ex Category section, Brand section, ...)
    var remainItem = 0;
    $('.js-data-controller[data-key="' + key + '"]').data('value', values.filter(function (item) {
        if (item != currentValue) {
            remainItem += 1;
        }
        return item != currentValue;
    }));

    if (key == 'brand' && (values.includes('original') || values.includes('buying'))) {
        setQueryStringDataSelectFilter($('.js-data-controller'), 'brand_type', values.filter(function (item) {
            return item != currentValue;
        }).toString().replace(/,/g, '|'));
    } else {
        setQueryString(key);
    }
    //[TL_FOR_RUBY-2938] If there is no tag remained, remove div col-12 that contains these tags
    if (remainItem === 0) {
        var divContainTags = $('.js-data-controller[data-key="' + key + '"]').find('div[class*="col-12"]');
        $(divContainTags).remove();
        //Remove inline style added when div contains tags
        $('.js-data-controller[data-key="' + key + '"]').attr("style", "");
    }
}

// maybe not use
function openModalLV2(key, _this) {
    var url = $(_this).data('url');
    var payload = $('.js-data-controller[data-key="' + key + '"]').data('query');
    payload = clean(payload);
    url += '?key=' + key + '&' + $.param(payload);
    url = url.replace(/&$/, '');
    $.ajax({
        url: url,
        type: 'GET',
        success: function (response) {
            if (!response.error) {
                $('.js-content-modal').html(response.html);
            }
        },
        error: function (error) {
        }
    });
}

function openModalChild(key, _this) {
    var url = $(_this).data('url');
    var payload = $(_this).data('query');
    if (!payload) {
        payload = $('.js-data-controller[data-key="' + key + '"]').data('query');
    }
    payload = clean(payload);
    url += '?key=' + key + '&' + $.param(payload);
    url = url.replace(/&$/, '');
    $.ajax({
        url: url,
        type: 'GET',
        success: function (response) {
            if (!response.error) {
                $('.js-content-modal').html(response.html);
                attachScrollEventToModal();
                hitCount();

                if ($(_this).hasClass('js-open-modal-lv2')) {
                    $('.modal-filter-sys').scrollTop(0);
                }
                //[TL_FOR_RUBY-2938] Change padding for sections with tags by default
                expandPaddingInTagSection();
            }
        },
        complete: function(data) {
            // only submit search box
            if ($(_this).hasClass('js-open-modal-filter') && $(window).width() >= 768) {
                $('body').find('.js-data-controller[data-key="keywords"] .js-input-change').trigger('focus');
                return;
            }

            // only level1
            if ($('body').find('.content-lv1').length > 0) {
                backToPositionLevel1();
            }
        },
        error: function (error) {
        }
    });
}

function validateAndLoadDataInput(_this, input, maxLength) {
    var aliasKey = $(_this).data('injectkey');
    var aliasValue = $(_this).data('injectvalue');
    var value = $(_this).val().toString().trim().slice(0, maxLength);
    var number = clearFormatNumber(value);
    var numberTXT = number.toString();
    if (isNaN(numberTXT)) {
        numberTXT = '';
    }
    $(_this).val(numberTXT);
    $('.js-data-controller[data-key="' + input + '"]').data(aliasValue, numberTXT);
    setQueryStringData(input, $('.js-data-controller[data-key="' + input + '"]').data(aliasKey), numberTXT);
}

function handleBrandSS(_this, key, payload) {
    var buyingKey = 'buying';
    var labelKey = 'label';
    var onlyOneItem;
    var tempObj = {};
    $('.js-content-modal :checkbox:checked').each(function () {
        var datakey = $(this).data('key');
        onlyOneItem = datakey;
        if (!tempObj[datakey]) {
            tempObj[datakey] = [];
        }

        if (tempObj[datakey]) {
            tempObj[datakey].push($(this).val());
        }
    });

    // just select 1 in 2
    if (onlyOneItem == buyingKey) {
        delete payload[labelKey]
    } else {
        delete payload[buyingKey]
    }

    if (tempObj[onlyOneItem]) {
        payload[onlyOneItem] = tempObj[onlyOneItem].join(',');
    }

    delete payload['brand_ss'];

    $(_this).data('query', payload);
    openModalChild(key, _this);
}

function handleCategory(_this, key) {
    var arrElement = $('.js-content-modal :checkbox:checked');
    var txt = [];
    arrElement.each((index, element) => {
        if (!!$(element).data('value2')) {
            var arrIDs = $(element).data('value2');
            if (arrIDs) {
                arrIDs = arrIDs.toString().split(',');
                for (let i = 0; i < arrIDs.length; i++) {
                    var id = arrIDs[i];
                    var ids = $('.js-content-modal :checkbox[data-parent=' + id + ']').map(function () {
                        return $(this).val();
                    }).get().join(',');
                    txt.push(ids);
                }
            }
        }
        else if (!!$(element).data('value3')) {
            txt.push($(element).data('value3'));
        }
        else {
            txt.push($(element).val());
        }
    });
    txt = txt.join(',');
    setQueryStringDataSelectFilter($('.js-select-filter'), 'category_prefix_final', txt);
    openModalChild(key, _this);
}

//hitCount

function hitCount() {
    var hitCount = 0;
    var isInputChecked = false;
    $('.modal-filter-sys .modal-body .checkbox-item input:checked').each(function() {
        if (typeof $(this).data('value') === 'undefined' || $(this).data('value') === null) return;
        hitCount += parseInt($(this).data('value'));
        if (!isInputChecked) {
            isInputChecked = true;
        }
    });
    var message;
    //[TL_FOR_RUBY-3008] Only when there exits an input checked then button message will show facet count.
    if (isInputChecked) {
        message = '決定 (' + hitCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")  + ')';
    } else {
        message = '決定';
    }
    $('.js-select-filter').text(message);
}

function backToPositionLevel1() {
    var positionLevel1 = sessionStorage.getItem('positionModalLevel1');
    $('.modal-filter-sys').scrollTop(positionLevel1);
}

// Event
// Staff start store rule: only choice 1 in 2
$('body').on('change', '.js_staffstart_store', function () {
    if ($(this).is(':checked')) {
        var currentDataKey = $(this).data('key');

        var targetDataKey = currentDataKey == 'coordinate_label_id' ? 'shop_code' : 'coordinate_label_id';

        $('.js_staffstart_store[data-key="' + targetDataKey + '"]').each(function () {
            $(this).prop('checked', false);
        });
    }
});

// active button
$('body').on('click', '.js-data-controller .modal-choose', function (e) {
    var dataKey = $(this).closest('.js-data-controller').attr('data-key');
    switch (dataKey) {
        case 'gender':
            setModalChoose('gender', this);
            break;
        case 'display_mode':
            setModalChoose('display_mode', this);
            break;
        case 'grouping':
            setModalChoose('grouping', this);
            break;
        case 'quantityItem':
            setModalChoose('quantityItem', this);
            break;
        case 'size':
            setModalChoose('size', this);
            break;
        case 'price_type':
            setModalChoose('price_type', this, true, true);
            break;
        case 'sale_flg':
            setModalChoose('sale_flg', this, true, true);
            break;
        case 'selling_type':
            setModalChoose('selling_type', this, true);
            break;
        case 'exclusive':
            setModalChoose('exclusive', this, true, true);
            break;
        case 'exclusive_flg':
            setModalChoose('exclusive_flg', this, true, true);
            break;
        case 'in_stock':
            setModalChoose('in_stock', this, true, true);
            break;
        case 'stock_none':
            var isHasClassActive = $(this).hasClass('modal-choose--active-2');
            var value = $('.js-data-controller[data-key="' + dataKey + '"]').data('value').toString() == 1 ? '0' : '1';
            if (!isHasClassActive) { // add
                $(this).addClass('modal-choose--active-2');
            } else { // remove
                $(this).removeClass('modal-choose--active-2');
            }
            $(this).data('value', value);
            $('.js-data-controller[data-key="' + dataKey + '"]').data('value', value);
            setQueryString(dataKey);
            break;
        default:
            break;
    }
    e.stopPropagation();
});


// Input Filter in Modal - Level 1
$('body').on('input', '.js-data-controller[data-key="offRatio"] .js-input-change', function (e) {
    e.stopPropagation();
    txtFullWidthCheck(this, 'offRatio', MAX_LENGTH_OFFRATIO);
})

$('body').on('input', '.js-data-controller[data-key="price"] .js-input-change', function (e) {
    e.stopPropagation();
    txtFullWidthCheck(this, 'price', MAX_LENGTH_PRICE);
})

$('body').on('blur', '.js-data-controller[data-key="keywords"] .js-input-change', function (e) { 
    const maxLength = 100;
    var currentLength = $(this).val().length;
    if (currentLength > maxLength) {
        $(this).val($(this).val().slice(0, maxLength));
    }
})

$('body').on('keydown keyup paste change', '.js-data-controller[data-key="keywords"] .js-input-change', function (e) {
    clearTimeout(setTimeOut);
    var aliasKey = $(this).data('injectkey');
    var aliasValue = $(this).data('injectvalue');
    var value = $(this).val().toString();
    $('.js-data-controller[data-key="keywords"]').data(aliasValue, value);
    setQueryStringData('keywords', $('.js-data-controller[data-key="keywords"]').data(aliasKey), value);

    if(e.which == 13) {
        $('.js-submit-filter').trigger('click');
    }

    var url = $(this).data('url'); // get url
    if (!url || !value) {
        $('.js-input-suggest-data').html('');
        $('.js-input-suggest-data').addClass('border-0')
        return;
    }
    url += '?q=' + value;
    setTimeOut = setTimeout(() => {
        $.ajax({
            url: url,
            type: 'GET',
            success: function (response) {
                if (!response.error) {
                    var data = response.data;
                    var html = '';
                    for (var i = 0; i < data.length; i++) {
                        var item = data[i];
                        html += '<div class="modal-keywords-suggestion--item">';
                        html += item.q;
                        html += '</div>';
                    }
                    $('.js-input-suggest-data').html(html);
                    $('.js-input-suggest-data').toggleClass('border-0', !data.length);
                }
            },
            error: function (error) {
                $('.js-input-suggest-data').html('');
                $('.js-input-suggest-data').addClass('border-0');
            }
        });
    }, 500);
})

$('body').on('click', '.modal-keywords-suggestion--item', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var _this = $('body').find('.js-data-controller[data-key="keywords"] .js-input-change');
    $(_this).val($(this).text());

    var aliasKey = $(_this).data('injectkey');
    var aliasValue = $(_this).data('injectvalue');
    var value = $(_this).val().toString();
    $('.js-data-controller[data-key="keywords"]').data(aliasValue, value);
    setQueryStringData('keywords', $('.js-data-controller[data-key="keywords"]').data(aliasKey), value);
    $('body').find('.js-data-controller[data-key="keywords"] .js-input-change').trigger('keyup blur');
});


$('body').on('input', '.js-input-same-type', function (e) {
    e.stopPropagation();
    if ($(this).is(':checked')) {
        var type = $(this).data('type');
        $('.js-input-same-type:not([data-type="' + type + '"])').prop('checked', false);
    }
    hitCount();
})
$('body').on('input', '.js-input-same-type-category', function (e) {
    e.stopPropagation();
    var id = null;
    var parent = null;
    if ($(this).is(':checked')) {
        id = $(this).data('id');
        parent = $(this).data('parent');
        if (!!id && !!parent) { // Check LV 3
            $('.js-input-same-type-category[data-id="' + parent + '"]').prop('checked', false);
            $('.js-input-same-type-category[data-parent="' + id + '"]').prop('checked', false);
        }
        else if (!!id) { // Check LV 2
            $('.js-input-same-type-category[data-parent="' + id + '"]').prop('checked', false);
            var arrElement = $('.js-input-same-type-category[data-parent="' + id + '"]');
            if (arrElement.length) {
                arrElement.each((index, element) => {
                    var eID = $(element).data('id');
                    $('.js-input-same-type-category[data-parent="' + eID + '"]').prop('checked', false);
                });
            }
        }
        else if (!!parent) { // Check LV 4
            $('.js-input-same-type-category[data-id="' + parent + '"]').prop('checked', false);
            parent = $('.js-input-same-type-category[data-id="' + parent + '"]').data('parent');
            if (!!parent) {
                $('.js-input-same-type-category[data-id="' + parent + '"]').prop('checked', false);
            }
        }
    }

    hitCount();
})

// height Item In Styling
$('body').on('input', '.js-data-controller[data-key="height"] .js-input-change', function (e) {
    e.stopPropagation();
    txtFullWidthCheck(this, 'height', MAX_LENGTH_HEIGHT);
})

// Remove Tag Selected
$('body').on('click', '.js-data-controller .js-modal-tag__close', function (e) {
    var dataKey = $(this).closest('.js-data-controller').attr('data-key');
    var _this = $(this).find('.modal-tag__close');
    if (dataKey == 'color' && $('body').find('.js-data-controller[data-key="color"] .js-modal-tag__close').length == 1) {
        $('body').find('.js-data-controller[data-key="grouping"]').removeClass('disable-event-bg');
    }
    e.stopPropagation();
    tagEffect(this, function() {
        removeTagSelected(dataKey, _this);
    });
});

// Submit Filter
$('body').on('click', '.js-submit-filter', function (e) {
    e.stopPropagation();
    tagEffect(this);
    updateKeyword();
    $('body').find('.js-data-controller[data-key="price"] .js-input-change').trigger('input');

    var payload = $('.js-data-controller').data('query');
    if (payload.category_prefix_final) {
        delete payload.category_prefix_final;
    }
    if (payload.brand && /original|buying/.test(payload.brand)) {
        payload.brand_type = payload.brand;
        delete payload.brand;
    }

    if (!payload.gender || payload.gender == "") {
        payload.gender = GENDER_ALL;
    }
    if (!getCookie('stock_none') && payload.stock_none) {
        setCookie('stock_none', payload.stock_none);
    }

    payload = clean(payload);
    payload.page = 1;

    var path = window.location.href.split('?')[0];
    if ($(this).data('url')) {
        path = $(this).data('url');
    }
    path += $.param(payload) ? '?' + $.param(payload) : '';
    window.location.href = path;
});

// click trend words
$('body').on('click', '.js-trend-words', function (e) {
    e.stopPropagation();
    var text = $(this).text().trim();
    $('body').find('.js-input-change').val(text).trigger('input');
});

// remove tag on PLP
$(function() {
    var isProcessing = false;
    $('body').on('click', '.js-plp-remove-tag, .js-plp-switch-gender', function (e) {
        e.stopPropagation();
        if (!isProcessing) {
            isProcessing = true;
            var elm = this;
            var payload = $(this).data('query');
            payload = clean(payload, 'reset-page');
            var path = window.location.href.split('?')[0];
            path += $.param(payload) ? '?' + $.param(payload) : '';
            if($(this).hasClass('js-plp-switch-gender')) {
                tagEffect(this, function() {
                    window.location.href = path;
                });
            } else {
                tagEffect(elm, function() {
                    // remove element
                    $(elm).remove();
                    window.location.href = path;
                });
            }
        }
    });
});

// Submit Select Filter
$('body').on('click', '.js-select-filter', function (e) {
    e.stopPropagation();
    var payload = $(this).data('query');
    var key = $(this).data('key');
    var keyreplace = $(this).data('keyreplace');
    var value = $('.js-content-modal :checkbox:checked').map(function () {
        return $(this).val();
    }).get();
    tagEffect(this);
    payload[keyreplace] = value.join(',');

    switch (keyreplace) {
        case 'category_prefix':
        case 'category':
            handleCategory(this, key);
            break;
        case 'brand_ss':
        case 'buying':
        case 'label':
            handleBrandSS(this, key, payload);
            break;
        case 'brand':
            delete payload['brand_type'];
            if (value.includes('original') || value.includes('buying')) {
                payload['brand_type'] = value.join(',');
                delete payload['brand'];
            }
            $(this).data('query', payload);
            openModalChild(key, this);
            break;
        default:
            $(this).data('query', payload);
            openModalChild(key, this);
            break;
    }
});

// Clear selected filter
$('body').on('click', '.js-clear-filter', function (e) {
    e.stopPropagation();
    tagEffect(this, null, 'bg');
    $('.js-content-modal :checkbox:checked').prop('checked', false);
    hitCount();
});

// Modal lv 1 -> Open to lv 2
$('body').on('click', '.js-data-controller', function (e) {
    e.stopPropagation();
    sessionStorage.setItem('positionModalLevel1', $('#modal-filter-plp').scrollTop());
    var _this = $(this).find('.js-open-modal-lv2');
    if (_this.length == 0 || !_this.data('key')) {
        return;
    }
    tagEffect(this, null, 'bg');
    openModalChild($(_this).data('key'), _this);
});

// Modal lv 2 -> back to lv 1
$('body').on('click', '.js-back-modal-lv1', function (e) {
    e.stopPropagation();
    tagEffect(this);
    openModalChild($(this).data('key'), this)
});

// handle button to top
var buttonToTop = $('.button_to_top');
$(window).on("scroll", function () {
    if ($(this).scrollTop()) {
        buttonToTop.addClass('show');
    } else {
        buttonToTop.removeClass('show');
    }
});

buttonToTop.on('click', function (e) {
    e.preventDefault();
    window.scrollTo(0,0);
});

// handle event radio grouping change
$('.js-grouping-radio-change, .js-sort-plp').on('change', function (e) {
    e.stopPropagation();
    var payload = $(this).data('query');
    var key = $(this).data('key');
    var valueDefault = $(this).data('valuedefault');
    if (key === 'stock_none') {
        payload[key] = $(this).prop('checked') === true ? $(this).val() : valueDefault
    } 
    else if (key === 'grouping') {
        payload[key] = $(this).prop('checked') === true ? $(this).val() : valueDefault
    }
    else {
        payload[key] = $(this).val() ? $(this).val() : valueDefault;
    }
    var path = window.location.href.split('?')[0];
    payload = clean(payload, 'reset-page');
    path += $.param(payload) ? '?' + $.param(payload) : '';
    window.location.href = path;
})
// handle button to top in modal
function attachScrollEventToModal() {
    $('.modal-body').on('scroll', function () {
        if ($(this).scrollTop()) {
            $('.btn-scrolltop').fadeIn();
        } else {
            $('.btn-scrolltop').fadeOut();
        }
    });
}

$(document).on('click', '.modal-filter-sys .checkbox-item.has-collapsed', function (e) {
    var dataTarget = $(this).data('target');
    var findParent = $(dataTarget).parent();
    tagEffect(this, null, 'bg');

    if (findParent.length > 0) {
        var nextElm = $(findParent).next().find('.checkbox-item');
    }

    if($(this).hasClass('collapsed')) {
        $(dataTarget).addClass('show');
        $(this).removeClass('collapsed');
        if (findParent.length > 0) {
            $(nextElm).addClass('js-rm-border');
        }
    }
    else {
        $(dataTarget).removeClass('show');
        $(this).addClass('collapsed');
        if (findParent.length > 0) {
            $(nextElm).removeClass('js-rm-border');  
        }
    }
    e.preventDefault();
});

$(document).on('click', '.btn-scrolltop', function (e) {
    $('.modal-body').scrollTop(0);
    e.preventDefault();
});


$('.modal-filter-sys').on("scroll", function() {
    if ($(this).scrollTop()) {
        $('.btn-scrolltop').fadeIn();
    } else {
        $('.btn-scrolltop').fadeOut();
    }
});

// event viewmore handle
var initViewmore = function () {
    if ($(window).width() >= 768) {
        $('.tag__viewmore').hide();
        $('.tag__wrap').addClass('active');
        $('.tag__wrap').parent().addClass('block_viewmore');

        $('.tag__viewmore--bc').hide();
        $('.tag__wrap--bc').addClass('active');
        $('.tag__wrap--bc').parent().addClass('block_viewmore');
    }

    if ($(window).width() <= 768 && $('.tag__wrap').height() > 100 ) {
        $('.tag__wrap').parent().addClass('block_viewmore');
        $('.tag__viewmore:not(.tag__viewmore--bc)').show();
        $('.tag__wrap').height(130);
        if (!$('.tag__viewmore').hasClass('active') && $('.tag__wrap').hasClass('active')) {
            $('.tag__viewmore').css('display', 'block');
            $('.tag__viewmore').show();
            $('.tag__wrap').removeClass('active');
        }
        
    }

    if ($(window).width() <= 768 && $('.tag__wrap--bc').height() > 55 ) {
        $('.tag__wrap--bc').parent().addClass('block_viewmore');
        $('.tag__viewmore--bc').show();
        $('.tag__wrap--bc').height(80);
        if (!$('.tag__viewmore--bc').hasClass('active') && $('.tag__wrap--bc').hasClass('active')) {
            $('.tag__viewmore--bc').css('display', 'block');
            $('.tag__viewmore--bc').show();
            $('.tag__wrap--bc').removeClass('active');
        }
    } else {
        $('.tag__viewmore--bc').hide();
    }
}

$(window).on('resize', function () {
    initViewmore();
});

function loadColumMobile() {
    if ($(window).width() < 768) {
        var display_column = getCookie('display_column');
        if (display_column) {
            if (display_column == 2) {
                $('.product-item').closest(".product").removeClass('activecolumn');
                $('.product-item').removeClass('is-active');
            }
            else {
                $('.product-item').closest(".product").addClass('activecolumn');
                $('.product-item').addClass('is-active');
            }
        }
    }
}

$(document).ready(function () {
    initViewmore();
    loadColumMobile();
    // isUserAgentChrome();

    $(document).on('focusin', 'input, textarea', function () {
        addViewPort();
    });

    $(document).on('focusout', 'input, textarea', function () {
        removeViewPort();
    });

    $(window).on('load', function (e) {
        if ($('.tag__viewmore').hasClass('active')) {
            $('.tag__viewmore').trigger('click');
        } else {
            $('.tag__viewmore').hide();
            $('.tag__wrap').addClass('active');
        }
        initViewmore()
        loadColumMobile();
    });
    pagenation.adjustMargins('.pc-display');
    pagenation.adjustMargins('.sp-display');
})

$('.js-open-modal-filter').on('click', function (e) {
    if ($(window).width() <= 768) {
        $('body').css('min-height', '100vh');
        SCROLL_Y = window.scrollY;
    }
    if ($('body').hasClass('lock_scroll')) {
        $('.header__hamburger').trigger('click');
        setTimeout(() => {
            var idModal = $(this).data('modal');
            $('.js-content-modal').html('');
            openModalChild('main', this);
            $(idModal).modal('show');
            // $('body').find('.js-data-controller[data-key="keywords"] .js-input-change').trigger('input');
        }, 500);
    } else {
        var idModal = $(this).data('modal');
        $('.js-content-modal').html('');
        openModalChild('main', this);
        $(idModal).modal('show');
        // $('body').find('.js-data-controller[data-key="keywords"] .js-input-change').trigger('input');
    }
})

$('.tag__viewmore').on('click', function (e) {
    if ($(this).hasClass('tag__viewmore--bc')) $(this).prev('.tag__wrap--bc').toggleClass('active');
    else $(this).prev('.tag__wrap').toggleClass('active');
    $(this).parent('.block_viewmore').toggleClass('active');
    $(this).toggleClass('active');
    $(this).text().trim() === $(this).data('txt') ? $(this).text($(this).data('txtclose')) : $(this).text($(this).data('txt'))
})

$('body').on('click', '.js-data-controller[data-key="keywords"] .icon-search', function (e) {
    $('body').find('.js-data-controller[data-key="keywords"] .js-input-change').val('').trigger('keyup');
    $('.js-input-suggest-data').html('');
    $('.js-input-suggest-data').addClass('border-0');
});

$('body').on('blur', '.js-data-controller[data-key="keywords"] .js-input-change', function (e) {
    $('.js-input-suggest-data').hide();
    $('.js-input-suggest-data').addClass('border-0');
});

$('body').on('mousedown', '.js-input-suggest-data', function (e) {
    e.preventDefault();
});

$('body').on('focus', '.js-data-controller[data-key="keywords"] .js-input-change', function (e) {
    $('.js-input-suggest-data').show();
    if ($('div.modal-keywords-suggestion--item').length > 0) {
        $('.js-input-suggest-data').removeClass('border-0');
    } else if ($('div.modal-keywords-suggestion--item').length == 0 && $(this).val()) {
        $(this).trigger('keyup');
    }
});

$('body').on('click', '.js-clearALL-filter', function (e) {
    tagEffect(this, null, 'bg');
    $('body').find('.js-data-controller[data-key="keywords"] .js-input-change').val('').trigger('keyup');
    $('body').find('.js-data-controller[data-key="grouping"]').removeClass('disable-event-bg');
    setModalChoose('gender', $('.js-data-controller[data-key="gender"] .modal-choose[data-value="30"]'));
    setModalChooseAllOrOne('selling_type', '.js-data-controller[data-key="selling_type"] .modal-choose');
    $('.modal-tag__close').trigger('click');
    setModalChooseAllOrOne('sale_flg', '.js-data-controller[data-key="sale_flg"] .modal-choose');
    setModalChooseAllOrOne('exclusive_flg', '.js-data-controller[data-key="exclusive_flg"] .modal-choose');
    setModalChooseAllOrOne('stock_none', '.js-data-controller[data-key="stock_none"] .modal-choose');
    $('.js-data-controller[data-key="offRatio"] .js-input-change').val('');
    $('.js-data-controller[data-key="price"] .js-input-change').val('');
    validateAndLoadDataInput($('.js-data-controller[data-key="offRatio"] .js-input-change[data-injectkey="key1"]'), 'offRatio', MAX_LENGTH_OFFRATIO);
    validateAndLoadDataInput($('.js-data-controller[data-key="offRatio"] .js-input-change[data-injectkey="key2"]'), 'offRatio', MAX_LENGTH_OFFRATIO);
    validateAndLoadDataInput($('.js-data-controller[data-key="price"] .js-input-change[data-injectkey="key1"]'), 'price', MAX_LENGTH_PRICE);
    validateAndLoadDataInput($('.js-data-controller[data-key="price"] .js-input-change[data-injectkey="key2"]'), 'price', MAX_LENGTH_PRICE);
    e.preventDefault();
})

function setCookie(cname, cvalue) {
    const d = new Date();
    d.setTime(d.getTime() + (30*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

$('.product-list__column02').on('click', function (e) {
    e.preventDefault();
    $('.product-item').closest(".product").removeClass('activecolumn');
    $('.product-item').removeClass('is-active');
    $('.product-list__column02').removeClass('is-active');
    $('.product-list__column03').addClass('is-active');
    setCookie('display_column', 2);
    return false;
})

$('.product-list__column03').on('click', function (e) {
    e.preventDefault();
    $('.product-item').closest(".product").addClass('activecolumn');
    $('.product-item').addClass('is-active');
    $('.product-list__column02').addClass('is-active');
    $('.product-list__column03').removeClass('is-active');
    setCookie('display_column', 3);
    return false;
})

$('body').on('click', '.modal-filter-sys .checkbox-item input', function(event) {
    tagEffect($(this).closest('.checkbox-item'),null, 'bg');
    hitCount();
});

// sort PLP mobile
$('#js-sort-data > p').on('click', function (e) {
    e.preventDefault();
    var value = $(this).data('value');
    var disabledClass = $(this).hasClass('disable-event-bg');
    // cancel click event
    if (disabledClass) {
        return false;
    }

    $('.js-sort-plp').val(value).trigger('change');
    $('[data-target="#js-sort-data"]').trigger('click');   
});

//onclick event for sortingButtonSelector ('[data-target="#js-sort-data"]')
$('[data-target="#js-sort-data"]').on('click', function (e) {
    //When the dropdown sorting is shown, bind the onclick event listener to object 'document'
    if ($(this).hasClass('collapsed')) {
        closeSPSortingButtonOnClickOutside();
    }
    // tagEffect(this);
    e.preventDefault();
});

//Close dropdown sorting button in SP
function closeSPSortingButtonOnClickOutside() {
    var dropdownSelector = $('#js-sort-data');
    var sortingButtonSelector = $('[data-target="#js-sort-data"]');
    function outsideClickListener (e) {
        //Check whether user click into the sortting button itself
        //If that the case, the onclick event for sortingButtonSelector will triggered already.
        if (!sortingButtonSelector.is(e.target) && sortingButtonSelector.has(e.target).length === 0) {
            //Check whether user click into the dropdown sortting button
            if (!dropdownSelector.is(e.target) && dropdownSelector.has(e.target).length === 0 && !$(sortingButtonSelector).hasClass('collapsed')) {
                //Since sorting button is a toggle, trigger click on it again for the dropdown sorting to close
                $(sortingButtonSelector).trigger("click");
                //Remove current event listener from document
                removeClickListener();
            }
        } else {
            //Clean up the listener when onclick event for sortingButtonSelector is triggered.
            removeClickListener();
        }
    }
    function removeClickListener() {
        document.removeEventListener('click', outsideClickListener, true);
    }
    //Initially, add event listener to document when called
    document.addEventListener('click', outsideClickListener, true);
}

function tagEffect(element, callback, type) {
    if ($(window).width() <= 768) {
        if (type == 'bg') {
            effect.effectChangeBackgroundColor(element, callback, effect.BEFORE_COLOR, effect.AFTER_COLOR);
        } else {
            effect.effectChangeOpacity(element, callback, effect.BEFORE_OPACITY, effect.AFTER_OPACITY);
        }
    }else {
        if (typeof callback === 'function') {
            callback();
        }
    }
}

$('body').on('click', '.custom__flex_wrap_plp a', function (e) {
    e.preventDefault();
    var href = $(this).attr('href');
    tagEffect(this, function () {  
        window.location = href;
    }, null);
});
$(document).on('click', 'a[class*="scroll-to-alphabet"]', function (e) {
    //Prevent the href tag to be added to URL
    e.preventDefault();
    //The href attr contains the id of the element to scroll to
    var alphabetDivId = $(this).attr('href').replace('#', '');

    //Scroll to the targeted div
    var element = document.getElementById(alphabetDivId);
    //Add top margin value by an amount of overlay element, in this case 'modal-header'
    //So that, after scrolling, the final position is the exact line without being overlayed by modal-header element
    var headerHeight = $('.modal-filter-sys .modal-header').outerHeight(true) || 0;
    tagEffect($(this).closest('.plp_alphabet__item'), function() {
        element.style.scrollMarginTop = headerHeight +'px';
        element.scrollIntoView();
        element.style.scrollMarginTop = 0;
    }, 'bg');
});

$('body').on('keydown', '.modal-keywords' , function(event) {
    if(event.which == 13) {
        $('.js-submit-filter').trigger('click');
    }
});

//Change padding for section if that section has tags (div class*='col-12')
function expandPaddingInTagSection() {
    var sections = document.querySelectorAll('div[class*="js-data-controller"]');
    const minSectionHeight = 50;
    for (var i = 0; i < sections.length; i++) {
        var section = sections[i];
        var matches = section.querySelectorAll('div[class*="option__choose__tag"]');
        if (matches.length > 0) {
            var titleDiv = section.querySelector('div[class*="col-3"]') ||  
                            section.querySelector('div[class*="title__option"]') || 
                            section.querySelector('div[class*="text-title"]');
            if (titleDiv) {
                var divHeight = titleDiv.offsetHeight;
                //Calculate padding height needed to change when section contain tags
                var paddingHeight = (minSectionHeight - divHeight) / 2;
                //Add inline styling padding to overwrite padding rule in css
                section.style.paddingTop = paddingHeight + "px";
                section.style.paddingBottom = paddingHeight + "px";
            }
        }
    }
}

function updateKeyword() {
    var elmKw = $('.modal-keywords');
    var aliasKey = $(elmKw).data('injectkey');
    var aliasValue = $(elmKw).data('injectvalue');
    var valKw = $(elmKw).val().toString();
    $('.js-data-controller[data-key="keywords"]').data(aliasValue, valKw);
    setQueryStringData('keywords', $('.js-data-controller[data-key="keywords"]').data(aliasKey), valKw);
}

$(document).on('click', '.plp-sys .tag_pair', function (e) {
    //Prevent the href tag to be added to URL
    e.preventDefault();
    var searchParams = new URLSearchParams($('.plp-sys').data('href') || '');
    searchParams.append('tag_pair', $(this).text().slice(1));

    tagEffect(this, function () {  
        window.location.href = window.location.pathname + '?' + searchParams;
    }, null);
});

$('body').on('click', '.plp-sys .product-item--image', function() {
    var currentParams = $('.plp-sys').data('href');
    sessionStorage.setItem('parameterPLP', currentParams);
})

var isUserAgentChrome = function(){
    var isChrome = false;
    var isAndroid = false;
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('chrome') > -1 && userAgent.indexOf('edg') === -1 && userAgent.indexOf('opr') === -1) {
        isChrome = true;
    }

    if (userAgent.indexOf('android') > -1) {
        isAndroid = true;
    }

    if (!isChrome && !isAndroid) {
        addViewPort();
    }
}

function removeViewPort() {
    var viewportMeta = document.querySelector('meta[name="viewport"]');
    if (viewportMeta) {
        var content = viewportMeta.getAttribute('content') || '';
        if (content.indexOf('maximum-scale') > -1) {
            content = content.replace(/,?\s*maximum-scale=[0-9.]+/, ''); 
            viewportMeta.setAttribute('content', content.trim());
        }
    }
}

function addViewPort() {
    var viewportMeta = document.querySelector('meta[name="viewport"]');
    if (viewportMeta) {
        var content = viewportMeta.getAttribute('content') || '';
        if (content.indexOf('maximum-scale') === -1) {
            content += (content.trim().length > 0 ? ', ' : '') + 'maximum-scale=1.0';
            viewportMeta.setAttribute('content', content.trim());
        }
    }
}

// /*
//  * Post-processing after close
//  */
$("#modal-filter-plp").on("hide.bs.modal", function () {
    if ($(window).width() <= 768) {
        $("body").css("position", "static");
        window.scrollTo(0, SCROLL_Y);
    }
});
$("#modal-filter-plp").on("hidden.bs.modal", function () {
    if ($(window).width() <= 768) {
        $(".modal-content").html("");
        window.scrollTo(0, SCROLL_Y);
    }
});

$("#modal-filter-plp").on("shown.bs.modal", function () {
    if ($(window).width() <= 768) {
        $(".modal-open").css("position", "fixed");
    }
});
function txtFullWidthCheck(_this, key, maxlength) {  
    if (isSafari()) {
        setTimeout(() => { // setTimeout fix bug delete on Safari
            validateAndLoadDataInput($(_this), key, maxlength);
        }, 300);
    } else {
        validateAndLoadDataInput($(_this), key, maxlength);
    }
}

$(document).ready(function () {
    if ($('div.page').data('action') == 'SearchPLP-Show') {
        var personalDataTopPage = $('input[name="personalData"]').val();
        if (personalDataTopPage) {
            personalDataTopPage = JSON.parse(personalDataTopPage);
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
                event: 'personaldata',
                members_id: personalDataTopPage.members_id,
                email: personalDataTopPage.email || '',
                phone: personalDataTopPage.phone || '',
                zipcode: personalDataTopPage.zipcode || ''
            });
        }
        window.dataLayer = window.dataLayer || [];
        var datalayerPLP = $('input[name="datalayerPLP"]').val();
        if (datalayerPLP) {
            datalayerPLP = JSON.parse(datalayerPLP);
            window.dataLayer.push({
                event: 'view_item_list',
                ecommerce: datalayerPLP
            });        
        }        
    }
});